const C = {
  name: "StaffTeam",
  dimensions: { width: 22, height: 22 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 4C8.79086 4 7 5.79086 7 8C7 10.2091 8.79086 12 11 12C13.2091 12 15 10.2091 15 8C15 5.79086 13.2091 4 11 4ZM9 8C9 6.89543 9.89543 6 11 6C12.1046 6 13 6.89543 13 8C13 9.10457 12.1046 10 11 10C9.89543 10 9 9.10457 9 8Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 2C6.02944 2 2 6.02944 2 11C2 12.8116 2.53527 14.4983 3.45629 15.9103C4.24766 14.1925 5.98457 13 8 13H14C16.0154 13 17.7523 14.1925 18.5437 15.9103C19.4647 14.4983 20 12.8116 20 11C20 6.02944 15.9706 2 11 2ZM11 20C8.70116 20 6.60363 19.1381 5.01291 17.7199C5.15418 16.1944 6.43761 15 8 15H14C15.5624 15 16.8458 16.1944 16.9871 17.7199C15.3964 19.1381 13.2988 20 11 20Z" fill="currentColor"/>
  `
};
export {
  C as StaffTeam
};
